import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import {
  Button,
  Container,
  Row,
  Col,
  Offcanvas,
  Form,
  InputGroup,
} from "react-bootstrap";
import {
  fetchCategoryData,
  fetchDmTeam,
  fetchInfSupportTeamList,
  fetchLanguageData,
  fetchLanguageDataByRoleId,
  influencerFollowerList,
} from "../../features/commonSlice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const filterTypes = [
 
  {
    label: "Own Influencer",
    value: "1",
  },
  {
    label: "Discover Influencer",
    value: "2",
  },
];

const filterChannel = [
  {
    label: "All",
    value: null,
  },
  {
    value: "youtube",
    label: "YouTube",
  },
  {
    value: "instagram",
    label: "Instagram",
  },
];

const influencerStatus = [
  {
    value: 99,
    label: "All Influencer",
  },
  {
    value: 1,
    label: "Active Influencer",
  },
  {
    value: 4,
    label: "Inactive Influencer",
  },
  {
    value: 0,
    label: "Pending  Influencer",
  },
];



const SubRequestFilter = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    showFiltersDrawer,
    setShowFiltersDrawer,
    formData,
    setFormData,
    handleFilter,
    filterType,
    handleReset,
    activeTab
  } = props;
  const [showFilters, setShowFilters] = useState(false);
  const [langList, setLangList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const {
    categoryData,
    languageData,
    languageDataByRoleId,
    dmTeamData,
    infSupportTeamData,
    inflfollowsData,
    status: commonStatus,
  } = useSelector((state) => state.influencer);

  console.log("activeTabactiveTabactiveTab ==>", activeTab);
  

  // const { inflfollowsData, languageData,
  //   genreData, status: commonStatus } = useSelector(
  //     (state) => state.influencer
  //   );

  const [followrsData, setFollowersData] = useState([]);

useEffect(() => {
  if (!formData?.inf_type) {
    setFormData((prev) => ({
      ...prev,
      inf_type: filterTypes[0], // Own Influencer
    }));
  }
}, []);

  useEffect(() => {
    dispatch(fetchCategoryData());
    dispatch(fetchDmTeam());
    dispatch(influencerFollowerList());
    dispatch(fetchInfSupportTeamList())
  }, [dispatch]);


  useEffect(() => {
  // Non-manual tabs always use RoleId API
  if (!activeTab || activeTab !== "manual") {
    dispatch(fetchLanguageDataByRoleId());
    return;
  }

  // Manual tab
  if (formData?.inf_type?.value === "1") {
    dispatch(fetchLanguageData()); // Own Influencer
  } else {
    dispatch(fetchLanguageDataByRoleId()); // Discover Influencer
  }
}, [dispatch, activeTab, formData?.inf_type?.value]);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setFollowersData([
        ...(inflfollowsData?.data || []),
      ]);
    }
  }, [inflfollowsData]);

  useEffect(() => {
    setCategoryList(categoryData);
    const selectedLanguageData =
  activeTab === "manual" &&
  formData?.inf_type?.value === "1"
    ? languageData?.data
    : languageDataByRoleId?.data;

    setLangList([
      {
        label: "All",
        value: null,
      },
      ...(selectedLanguageData || []),
    ]);

    setUsersList([
      {
        label: "All",
        value: null,
      },
      ...(dmTeamData?.data || []),
    ]);
  }, [commonStatus,
  categoryData,
  languageData,
  languageDataByRoleId,
  dmTeamData,
  activeTab,
  formData?.inf_type?.value]);

  useEffect(() => {
    console.log("language ===>", langList);
  }, [langList]);

  const handleSelectChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInputChange = (e, key, type = "text") => {
    const { value, dataset } = e.target;

    setFormData((prev) => {
      // ✅ RANGE INPUT (budget, subscribers, views)
      if (type === "range") {
        return {
          ...prev,
          [key]: {
            ...prev[key],
            [dataset.range]: value,
          },
        };
      }

      // ✅ NORMAL INPUT (text, number)
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      channel_name: checked
        ? [...prev.channel_name, value]
        : prev.channel_name.filter((item) => item !== value),
    }));
  };

  useEffect(() => {
    console.log("user list ==>", usersList);
  }, [usersList]);

  return (
    <Offcanvas
      show={showFiltersDrawer}
      onHide={() => setShowFiltersDrawer(false)}
      placement="end"
      style={{ width: "400px" }}
      className="m-0"
    >
      <Offcanvas.Header closeButton className="border-bottom py-3">
        <h5>
          <h5>
            {filterType === "active" && "Active Influencer Filters"}
            {filterType === "assigned" && "Assigned Influencer Filters"}
            {filterType === "inactive" && "Inactive Influencer Filters"}
            {filterType === "pending" && "Pending Influencer Filters"}
            {filterType === "all" && "All Influencer Filters"}
            {filterType === "activeClient" && "Active Influencer Filters"}
            {filterType === "inactiveClient" && "Inactive Influencer Filters"}
            {filterType === "assignClient" && "Assign Influencer Filters"}
            {filterType === "pendingClient" && "Pending Client Filters"}
            {filterType === "allClient" && "All Client Filters"}
          </h5>
        </h5>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="row mb-4">
          {/* {filterType === "active" && ( */}
          <>
            <div className="col-lg-12 py-2">
              <div class="form-group">
                <label for="exampleInputEmail1">Influence Type</label>
                <Select
                  name="inf_type"
                  options={filterTypes}
                  classNamePrefix="select"
                  placeholder="Select influence type"
                  onChange={(selected) =>
                    handleSelectChange("inf_type", selected)
                  }
                  value={formData.inf_type}
                />
              </div>
            </div>
            {activeTab !== "manual" && <div className="col-lg-12 py-2">
              <div class="form-group">
                <label>Managed By</label>
                <Select
                  name="userName"
                  options={usersList}
                  classNamePrefix="select"
                  placeholder="Select user"
                  onChange={(selected) =>
                    handleSelectChange("userName", selected)
                  }
                  value={formData.userName}
                />
              </div>
            </div>}
            <div className="col-lg-12 py-2">
              <div class="form-group">
                <label>Follower / Subscriber</label>
                <Select
                  name="follower_subscriber"
                  options={followrsData}
                  classNamePrefix="select"
                  placeholder="Select follower / subscriber"
                  onChange={(selected) =>
                    handleSelectChange("follower_subscriber", selected)
                  }
                  value={formData.follower_subscriber}
                />
              </div>
            </div>

            <div className="col-lg-12 py-2">
              <div class="form-group">
                <label>Channel Type</label>
                <Select
                  name="filter_channel"
                  options={filterChannel}
                  classNamePrefix="select"
                  placeholder="Select filter channel"
                  onChange={(selected) =>
                    handleSelectChange("filter_channel", selected)
                  }
                  value={formData.filter_channel}
                />
              </div>
            </div>
            {activeTab !== "manual" && <div className="col-lg-12 py-2">
              <div class="form-group">
                <label>Influencer Status</label>
                <Select
                  name="infnr_status"
                  options={influencerStatus}
                  classNamePrefix="select"
                  placeholder="Select influencer status"
                  onChange={(selected) =>
                    handleSelectChange("infnr_status", selected)
                  }
                  value={formData.infnr_status}
                />
              </div>
            </div>}
            <div className="col-lg-12 py-2">
              <div class="form-group">
                <label>Language</label>
                <Select
                  name="language_filter"
                  options={langList}
                  classNamePrefix="select"
                  placeholder="Select user"
                  onChange={(selected) =>
                    handleSelectChange("language_filter", selected)
                  }
                  value={formData.language_filter}
                />
              </div>
            </div>
          </>
          {/* )} */}
        </div>
        {/* <form
          action="#"
          className="d-flex flex-column justify-content-end h-100"
        >
          <div className="offcanvas-body">
            <div className="mb-1">
              <label
                htmlFor="language-select"
                className="form-label text-muted text-uppercase fw-semibold mb-2 small"
              >
                Language
              </label>
              <Select
                isMulti
                name="languages"
                options={langList?.data}
                classNamePrefix="select"
                onChange={(selected) =>
                  handleSelectChange("languages", selected)
                }
                value={formData.languages}
              />
            </div>
            <div className="mb-3">
              <label
                htmlFor="status-select"
                className="form-label text-muted text-uppercase fw-semibold mb-2 small"
              >
                Channel
              </label>
              <div className="row g-2">
                {["Youtube", "Instagram", "Facebook", "Linkedin"].map((channel, index) => (
                  <div className="col-lg-6" key={index}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`inlineCheckbox${index}`}
                        value={channel}
                        checked={formData.channel_name.includes(channel)}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor={`inlineCheckbox${index}`}>
                        {channel}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mb-3">
              <label
                htmlFor="budget"
                className="form-label text-muted text-uppercase fw-semibold mb-2  small"
              >
                Budget
              </label>
              <div className="row g-2 align-items-center">
                <div className="col-lg">
                  <input
                    type="number"
                    className="form-control"
                    id="budget-min"
                    placeholder="0"
                    data-range="min"
                    value={formData.budget.min}
                    onChange={(e) => handleInputChange(e, "budget", "range")}
                  />
                </div>
                <div className="col-lg-auto">To</div>
                <div className="col-lg">
                  <input
                    type="number"
                    className="form-control"
                    id="budget-max"
                    placeholder="0"
                    data-range="max"
                    value={formData.budget.max}
                    onChange={(e) => handleInputChange(e, "budget", "range")}
                  />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <label
                htmlFor="select-categories"
                className="form-label text-muted text-uppercase fw-semibold mb-2 small"
              >
                Categories
              </label>
              <Select
                isMulti
                name="categories"
                options={categoryList?.data}
                classNamePrefix="select"
                onChange={(selected) =>
                  handleSelectChange("categories", selected)
                }
                value={formData.categories}
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="subscribers"
                className="form-label text-muted text-uppercase fw-semibold mb-2 small"
              >
                Subscribers
              </label>
              <div className="row g-2 align-items-center">
                <div className="col-lg">
                  <input
                    type="number"
                    className="form-control"
                    id="subscribers-min"
                    placeholder="0"
                    data-range="min"
                    value={formData.subscribers.min}
                    onChange={(e) => handleInputChange(e, "subscribers", "range")}
                  />
                </div>
                <div className="col-lg-auto">To</div>
                <div className="col-lg">
                  <input
                    type="number"
                    className="form-control"
                    id="subscribers-max"
                    placeholder="0"
                    data-range="max"
                    value={formData.subscribers.max}
                    onChange={(e) => handleInputChange(e, "subscribers", "range")}
                  />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <label
                htmlFor="views"
                className="form-label text-muted text-uppercase fw-semibold mb-2 small"
              >
                Views
              </label>
              <div className="row g-2 align-items-center">
                <div className="col-lg">
                  <input
                    type="number"
                    className="form-control"
                    id="views-min"
                    placeholder="0"
                    data-range="min"
                    value={formData.views.min}
                    onChange={(e) => handleInputChange(e, "views", "range")}
                  />
                </div>
                <div className="col-lg-auto">To</div>
                <div className="col-lg">
                  <input
                    type="number"
                    className="form-control"
                    id="views-max"
                    placeholder="0"
                    data-range="max"
                    value={formData.views.max}
                    onChange={(e) => handleInputChange(e, "views", "range")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 offcanvas-footer border-top text-center hstack gap-2 small">
            <button
              type="button"
              className="btn btn-light w-100 small"
              onClick={() => setFormData({
                channel_name: [],
                categories: [],
                languages: [],
                budget: { min: "", max: "" },
                subscribers: { min: "", max: "" },
                views: { min: "", max: "" }
              })}
            >
              Clear Filter
            </button>
            <button type="button" className="btn btn-success w-100  small" onClick={handleFilter}>
              Filters
            </button>
          </div>
        </form> */}
        <div className="col-sm-12 offcanvas-footer border-top text-center hstack gap-2 py-4 small">
          <button
            type="button"
            className="btn btn-danger w-100 small"
            onClick={handleReset}
          >
            Clear Filter
          </button>
          <button
            type="button"
            className="btn btn-info w-100  small"
            onClick={handleFilter}
          >
            Filters
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SubRequestFilter;
